import React from "react"

const NotFoundIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
    >
      <path
        d="M42.5564 42.5564C40.5135 44.5992 38.0882 46.2198 35.419 47.3254C32.7499 48.431 29.8891 49 27 49C24.1109 49 21.2501 48.431 18.581 47.3254C15.9118 46.2198 13.4865 44.5992 11.4437 42.5564C9.40076 40.5135 7.78025 38.0882 6.67465 35.419C5.56905 32.7499 5 29.8891 5 27C5 24.1109 5.56905 21.2501 6.67465 18.581C7.78025 15.9118 9.40076 13.4865 11.4437 11.4437C13.4865 9.40076 15.9118 7.78025 18.581 6.67465C21.2501 5.56905 24.1109 5 27 5C29.8891 5 32.7499 5.56905 35.419 6.67465C38.0882 7.78025 40.5135 9.40076 42.5564 11.4437C44.5992 13.4865 46.2198 15.9118 47.3254 18.581C48.431 21.2501 49 24.1109 49 27C49 29.8891 48.431 32.7499 47.3254 35.419C46.2198 38.0882 44.5992 40.5135 42.5564 42.5564ZM42.5564 42.5564L55 55M27.6286 36.68H27.6489M27.6286 16.3143V29.0429"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default NotFoundIcon
